import { render, staticRenderFns } from "./table-liberacao.vue?vue&type=template&id=7fa85ab2&"
import script from "./table-liberacao.vue?vue&type=script&lang=js&"
export * from "./table-liberacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports